import { createSlice } from "@reduxjs/toolkit";
import { initialAdminData, initialState, initialUserData } from "./constants";
import {
    applyCommonUserData,
    applyUserData,
    applyAdminCafeList,
} from "./stateMappers";
import {
    fetchAdminChecklistId,
    fetchAdminInfo,
    fetchCafes,
    fetchChecklistID,
    fetchUserInfo,
    updateUserExp,
} from "./thunks";

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserProgress: (state, action) => {
            state.userData.level = action.payload.newLevel;
            state.userData.totalExp = action.payload.newExp;
        },
        resetUserState: () => {
            return {
                ...initialState,
                userData: { ...initialUserData },
                adminData: { ...initialAdminData },
            };
        },
        setSelectedAdminCafe: (state, action) => {
            state.adminData.cafeId = action.payload.cafeId;
            state.adminData.maxCountEmp = action.payload.maxCountEmp;
        },
        setAdminCafeList: (state, action) => {
            applyAdminCafeList(state, action.payload);
        },
        setProfilePhoto: (state, action) => {
            state.profilePhotoUrl = action.payload;
        },
        setUserName: (state, action) => {
            state.name = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
            applyCommonUserData(state, action.payload);
            applyUserData(state, action.payload);
            state.loaded = true;
        });

        builder.addCase(fetchUserInfo.rejected, (state) => {
            state.loaded = true;
        });

        builder.addCase(updateUserExp.fulfilled, (state, action) => {
            state.userData.level = action.payload.newLevel;
            state.userData.totalExp = action.payload.newExp;
        });

        builder.addCase(fetchChecklistID.fulfilled, (state, action) => {
            state.userData.checklistId = action.payload;
        });

        builder.addCase(fetchAdminChecklistId.fulfilled, (state, action) => {
            state.adminData.checklistId = action.payload.id;
        });

        builder.addCase(fetchCafes.pending, (state) => {
            applyAdminCafeList(state, []);
            state.adminData.cafesLoading = true;
        });

        builder.addCase(fetchCafes.fulfilled, (state, action) => {
            applyAdminCafeList(state, action.payload);
            state.adminData.cafesLoading = false;
        });

        builder.addCase(fetchCafes.rejected, (state) => {
            applyAdminCafeList(state, []);
            state.adminData.cafesLoading = false;
        });

        builder.addCase(fetchAdminInfo.fulfilled, (state, action) => {
            const commonData = action.payload.commonData;
            applyCommonUserData(state, commonData);

            if (action.payload.adminData?.cafes) {
                applyAdminCafeList(state, action.payload.adminData.cafes);
            }

            const userData = action.payload.userData;
            if (userData) {
                applyCommonUserData(state, userData);
                applyUserData(state, userData);
            }

            state.loaded = true;
        });

        builder.addCase(fetchAdminInfo.rejected, (state) => {
            state.loaded = true;
        });
    }
});

export const {
    setUserProgress,
    resetUserState,
    setSelectedAdminCafe,
    setAdminCafeList,
    setProfilePhoto,
    setUserName,
} = userSlice.actions;

export default userSlice.reducer;
